const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getNodeMessage = (message, date) => {
  if (date) {
    try {
      const jsDate = new Date(`${date.replace(/-/g, '/')} UTC`);

      return `${message} ${monthNames[jsDate.getMonth()]}. ${jsDate.getDate()}`;
    } catch (error) {
      return message;
    }
  }

  return message;
};
